import { useState } from 'react'
import { IoRocketOutline } from 'react-icons/io5'
import DemoModal from '@/Components/DemoModal'

const reasonsToChoose = [
    {
        id: 1,
        header: 'User-Friendly Dashboard',
        text: 'Intuitive design for easy navigation and quick access to HR data.',
    },
    {
        id: 2,
        header: 'Automated & Efficient',
        text: 'AI-powered automation reduces manual work and increases accuracy.',
    },
    {
        id: 3,
        header: 'Secure & Scalable',
        text: 'Enterprise-grade security ensures data protection, with flexible scaling options.',
    },
]

const WhyChooseHRMSPORTALS = () => {
    const [isDemoModalOpen, setIsDemoModalOpen] = useState(false)

    return (
        <>
            <section className='py-12'>
                <div className='flex flex-col gap-10 px-2 md:px-10 lg:flex-row xl:px-36'>
                    <div className='flex flex-1 items-center justify-center'>
                        <h3 className='w-fit text-center text-4xl font-bold !leading-[140%] md:text-6xl lg:text-left'>
                            Why choose <span className='text-[#FF3B38]'>HRMSPORTALS?</span>
                        </h3>
                    </div>
                    <div className='flex flex-1 flex-col gap-8'>
                        {reasonsToChoose.map((reason, index) => (
                            <div key={reason.id} className='border border-[#CCCCCC] bg-white px-6 py-5'>
                                <div className='flex items-center gap-4'>
                                    <div className='aspect-square rounded-full bg-[#FF3B38] py-1 px-3 text-2xl font-bold text-white'>
                                        {index + 1}
                                    </div>
                                    <p className='text-xl font-semibold'>{reason.header}</p>
                                </div>
                                <div className='mt-4 font-semibold text-[#646569]'>{reason.text}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='mt-12'>
                    <button 
                        onClick={() => setIsDemoModalOpen(true)}
                        className='mx-auto flex items-center gap-3 bg-[#FF3B38]  py-2 px-4 font-semibold text-white shadow-[2px_2px_12px_0px_#00000026]  transition-all duration-300 ease-outout hover:scale-105 hover:bg-[#FF3B38] '>
                        <IoRocketOutline className='text-2xl' />
                        Get a demo
                    </button>
                </div>
            </section>
            <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} />
        </>
    )
}

export default WhyChooseHRMSPORTALS
